import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ReactMarkdown from 'react-markdown';

import { resolveMediaUrl } from '../utils/media';
import { markdownToExcerpt } from '../utils/text';
import Seo from './Seo';

const PageContent = ({ url }) => {
  const [pageContent, setPageContent] = useState('');
  const [pageTitle, setPageTitle] = useState('');
  const [featuredImage, setFeaturedImage] = useState(null);
  const [seoData, setSeoData] = useState({ seo_title: '', seo_desc: '' });

  // Fetch the content based on the URL
  useEffect(() => {
    axios
      .get('https://joli-mot.fr/api-2026.php', {
        params: { 
          cleApi: '34KVHFQSP226YTk4n256QP6rGbqhA5w2ymY7W3pLwdbuc3i75',
          service: 'getPageByUrl',
          url: url
        }
      })
      .then(response => {
        const pageData = response.data.data;
        setPageContent(pageData.contenu);
        setPageTitle(pageData.titre);

        // Mettre à jour les données SEO
        setSeoData({
          seo_title: pageData.meta_title || pageData.titre || 'Page JoliMot.fr',
          // Sans description saisie dans l'admin : le début du contenu de la page.
          seo_desc: pageData.meta_description || markdownToExcerpt(pageData.contenu, 155) || pageData.titre,
        });

        // Si l'image est présente, la stocke dans l'état
        if (pageData.featured_image) {
          setFeaturedImage(pageData.featured_image);
        }
      })
      .catch(error => {
        console.error('Erreur lors de la récupération du contenu de la page !', error);
      });
  }, [url]); // Exécuter lorsque l'URL change

  return (
    <Box sx={{ padding: 3, position: 'relative' }}>
      {/* SEO Helmet */}
      {seoData.seo_title && <Seo titre={seoData.seo_title} description={seoData.seo_desc} path={`/${url}`} />}

      <Typography variant="h1" sx={{ marginBottom: 4, textAlign: 'center' }}>
        {pageTitle}
      </Typography>

      {featuredImage && (
        <img
          src={resolveMediaUrl(featuredImage)}
          alt="Featured"
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '150px',
            height: '150px',
            objectFit: 'cover',
            borderRadius: '50%',
            margin: '10px'
          }}
        />
      )}

      {/* Affiche le contenu récupéré */}
      <Box sx={{ marginTop: 5 }}>
        <ReactMarkdown
          components={{
            // Le titre de la page est déjà le <h1> : un « # » du contenu devient un <h2>.
            h1: ({ node, ...props }) => <h2 {...props} />,
            img: ({ node, src, alt, ...props }) => (
              <img src={resolveMediaUrl(src)} alt={alt || ''} {...props} />
            ),
          }}
        >
          {pageContent}
        </ReactMarkdown>
      </Box>
    </Box>
  );
};

export default PageContent;
